import { Grid, Menu, MenuItem, Typography } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { useSnackbar } from "notistack";
import PropTypes from "prop-types";

import IFrameComponent from "../components/IFrameComponent";
import IFrameControl from "../components/IFrameControl";
import StyledTabs from "../components/StyledTabs";
import TabStyle from "../components/TabStyle";
import { useAppInsights } from "../components/AppInsightsProvider";
import ControlComponent from "../components/ControlComponent";
import HelpModal from "../components/HelpModalComponent";
import { actionToLog } from "../store/ducks/duckAudit";
import MEETINGSPRE from "../constants/meetings";
import MEETINGSANNUAL from "../constants/meetingsAnnual";
import ButtonOpenAnotherTab from "../components/ButtonOpenAnotherTab";
import replaceQueryParam from "../utils/urlReplaceQueryParam";
import { resetReunionData } from "../store/ducks/duckLayoutCustom";
import { resetHistory } from "../store/ducks/duckLayout";

export const getFilterForLog = (history) => {
  let result = "";

  for (const key in history) {
    const value = history[key];

    result += `${key}=${value}, `;
  }

  return result;
};

const LayoutWithTabs = (props) => {
  const { isCustom = false } = props;
  const { tabs } = useSelector((state) => state.layout.layoutSelected);

  const { enqueueSnackbar } = useSnackbar();
  const { reunionSelected } = useSelector((state) => state.layoutCustom);

  const [renderMenu, setRenderMenu] = useState(0);
  const dispatch = useDispatch();

  const defaultTab = useSelector((state) =>
    state.layout.layoutSelected?.tabs ? state.layout.layoutSelected?.tabs[0]?.tabId : 0,
  );

  const [tab, setTab] = useState(defaultTab);
  const [, setPreviousTab] = useState(null);
  const [selectedTabs, setSelectedTabs] = useState([defaultTab]);
  const [tabWithMenu, setTabWithMenu] = useState(null);
  const [clickTab, setClickTab] = useState(false);
  const appInsights = useAppInsights();
  const isPre = () => {
    let locationArray = location.pathname.split("/");
    let actualLocation = locationArray.pop();

    return actualLocation === "PRE";
  };
  const handleChange = (_, newValue) => {
    let tabItemSelected = tabs.find((x) => x.tabId === newValue);
    let isMenu = tabItemSelected.redirectSources;

    if (newValue !== 0 && !isMenu) {
      setTab(newValue);
      setPreviousTab(tab);
      setSelectedTabs([...selectedTabs, newValue]);
    } else if (newValue !== 0 && isMenu) {
      setTabWithMenu(newValue);
    }
  };
  const { history, historyLoaded } = useSelector((state) => state.layout);

  useEffect(() => {
    setSelectedTabs([tab]);
    // eslint-disable-next-line
  }, [history, historyLoaded]);
  useEffect(() => {
    return () => dispatch(resetReunionData());
  }, [dispatch]);
  useEffect(() => {
    dispatch(resetHistory());
  }, []);

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClickTab = (tabId) => (event) => {
    let tabSelected = tabs.find((x) => x.tabId === tabId);

    if (tabSelected.redirectSources) {
      setAnchorEl(event.currentTarget);
    }

    if (tabSelected) {
      let { tabId, tabValue, sourceUrl } = tabSelected;

      if (tabValue === "Backlog") {
        setClickTab(true);
      } else {
        setClickTab(false);
      }

      appInsights.setAuthenticatedUserContext(localStorage.getItem("Email"));
      appInsights.trackEvent({
        name: "TabSelected",
        properties: { TabId: tabId, TabValue: tabValue, SourceUrl: sourceUrl },
      });

      dispatch(
        actionToLog({
          action: "CLICK",
          pathMenu: location.pathname,
          resource: "Tab",
          resourceId: tabId,
          details: JSON.stringify(history),
          category: "TAB",
        }),
      );
    }
  };

  const populateUrl = (template) => {
    let urlTemplate = template;

    moment.locale("es");
    var localLocale = moment();

    localLocale.locale(false);

    let monthDefault = localLocale.subtract(2, "months").format("MMM");
    let yearDefault = localLocale.subtract(2, "months").format("YYYY");

    let month = history && history["MONTH"] ? history["MONTH"] : monthDefault;
    let year = history && history["YEAR"] ? history["YEAR"] : yearDefault;

    urlTemplate = urlTemplate.replace("{YEAR}", year);
    urlTemplate = urlTemplate.replace("{MONTH}", month.toUpperCase().replace(".", ""));
    if (history) {
      for (const key in history) {
        if (history.hasOwnProperty(key)) {
          const element =
            history[key] && history[key]?.trim() !== "TOTAL" && history[key] !== ""
              ? history[key]
              : "";

          urlTemplate = urlTemplate.replaceAll(`{${key}}`, element);
        }
      }
    }

    return urlTemplate;
  };

  const handleClickMenuItemRedirect = (url) => (event) => {
    event.preventDefault();
    let urlProcesed = populateUrl(url);

    enqueueSnackbar("Opened in another Tab", {
      variant: "info",
    });
    window.open(urlProcesed, "_blank", "noopener,noreferrer");
  };

  const handleClickMenuItemRedirectCashflow = (url) => (event) => {
    event.preventDefault();
    let urlProcesed = populateUrl(url);

    if (isCustom) {
      if (history && history["REUNION"] && location.pathname.includes("PRE")) {
        let reunion = history["REUNION"];

        reunion = reunion.toUpperCase().replace(" ", "");
        let MEETINGS = MEETINGSPRE;

        if (MEETINGS.hasOwnProperty(reunion)) {
          urlProcesed = MEETINGS[reunion].cashflow;
        }
      } else if (history && history["Budget"] && location.pathname.includes("Annual")) {
        let reunion = history["Budget"];
        let MEETINGS = MEETINGSANNUAL;

        if (MEETINGS.hasOwnProperty(reunion)) {
          urlProcesed = MEETINGS[reunion].cashflow;
        }
      }
    }

    enqueueSnackbar("Opened in another Tab", {
      variant: "info",
    });
    window.open(urlProcesed, "_blank", "noopener,noreferrer");
  };

  const menuItems = (tabS) => {
    let result = [];

    if (isCustom) {
      if (history && history["REUNION"]) {
        let reunion = history["REUNION"];

        reunion = reunion.toUpperCase().replace(" ", "");
        let MEETINGS = location.pathname.includes("PRE") ? MEETINGSPRE : MEETINGSANNUAL;

        if (MEETINGS.hasOwnProperty(reunion)) {
          let attachments = MEETINGS[reunion].attachments;

          for (let attc in attachments) {
            if (attachments.hasOwnProperty(attc)) {
              let { url, label } = attachments[attc];

              result.push(
                <MenuItem key={`${attc}-${tab}`} onClick={handleClickMenuItemRedirect(url)}>
                  {label}
                </MenuItem>,
              );
            }
          }
        }
      } else if (history && history["Budget"]) {
        let reunion = history["Budget"];

        reunion = reunion.toUpperCase().replace(" ", "");
        let MEETINGS = MEETINGSANNUAL;

        if (MEETINGS.hasOwnProperty(reunion)) {
          let attachments = MEETINGS[reunion].attachments;

          for (let attc in attachments) {
            if (attachments.hasOwnProperty(attc)) {
              let { url, label } = attachments[attc];

              result.push(
                <MenuItem key={`${attc}-${tab}`} onClick={handleClickMenuItemRedirect(url)}>
                  {label}
                </MenuItem>,
              );
            }
          }
        }
      }
    } else {
      let tabSelected = tabs.find((x) => x.tabId === tabS);

      if (tabSelected && tabSelected.redirectSources) {
        result = tabSelected.redirectSources.map((rs, i) => (
          <MenuItem key={`${rs.name}-${i}`} onClick={handleClickMenuItemRedirect(rs.url)}>
            {rs.name}
          </MenuItem>
        ));
      }
    }

    return result;
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const changeUrl = useCallback(
    ({ sourceUrl, tabId }) => {
      if (history && history.hasOwnProperty("Budget")) {
        //TO DO: Es para salir del paso, no debería ser así, pero es un caso unico por dev en el que se cambia
        //la url completa.
        let MEETINGS = MEETINGSANNUAL;
        let reunion = history["Budget"];

        // if ((reunion && MEETINGS.hasOwnProperty(reunion)) || isJUN2021) {
        if (reunion && history.hasOwnProperty("Budget")) {
          let tabLabel = tabs.find((x) => x.tabId === tabId)?.tabValue;

          let meeting = MEETINGS[reunion.replace(" ", "")];

          // if ((reunionSelected && MEETINGS.hasOwnProperty(reunionSelected)) || isJUN2021) {
          //   let tabLabel = tabs.find((x) => x.tabId === tabId)?.tabValue;
          //   let meeting = MEETINGS[isJUN2021 ? "JUN2021" : reunionSelected];

          //Lo mismo que arriba, no debería funcionar de esta forma si no se cambiara la url en total.
          tabLabel = tabLabel.toLowerCase();
          tabLabel = tabLabel.replace(" ", "").replace("&", "");

          if (meeting && meeting.hasOwnProperty(tabLabel)) {
            let id = meeting[tabLabel];

            let result = replaceQueryParam("documentID", id, sourceUrl);

            // if (history["REUNION"] === "JUN 2021" || history["REUNION"] === "FEB 2022")

            if (id.includes("https")) result = id;

            return result;
          }
        }
      }

      if (history && history.hasOwnProperty("REUNION")) {
        let isJUN2021 = history["REUNION"] === "JUN 2021";

        //TO DO: Es para salir del paso, no debería ser así, pero es un caso unico por dev en el que se cambia
        //la url completa.
        let MEETINGS = location.pathname.includes("PRE") ? MEETINGSPRE : MEETINGSANNUAL;
        let reunion = history["REUNION"];

        // if ((reunion && MEETINGS.hasOwnProperty(reunion)) || isJUN2021) {
        if (reunion && history.hasOwnProperty("REUNION")) {
          let tabLabel = tabs.find((x) => x.tabId === tabId)?.tabValue;

          let meeting = MEETINGS[isJUN2021 ? "JUN2021" : reunion.replace(" ", "")];

          // if ((reunionSelected && MEETINGS.hasOwnProperty(reunionSelected)) || isJUN2021) {
          //   let tabLabel = tabs.find((x) => x.tabId === tabId)?.tabValue;
          //   let meeting = MEETINGS[isJUN2021 ? "JUN2021" : reunionSelected];

          //Lo mismo que arriba, no debería funcionar de esta forma si no se cambiara la url en total.
          tabLabel = tabLabel.toLowerCase();
          tabLabel = tabLabel.replace(" ", "");
          if (meeting && meeting.hasOwnProperty(tabLabel)) {
            let id = meeting[tabLabel];

            //TODO: Es un parche provisorio para los que solo tienen ID
            if (!id.includes("https")) {
              meeting = MEETINGS["AGO2021"];
              id = meeting[tabLabel];
            }

            let result = replaceQueryParam("documentID", id, sourceUrl);

            // if (history["REUNION"] === "JUN 2021" || history["REUNION"] === "FEB 2022")

            if (id.includes("https")) result = id;

            return result;
          }
        }
      }

      return sourceUrl;
    },
    [history, tabs],
  );

  const tabsIframe =
    tabs &&
    renderMenu === 3 &&
    tabs.map((tabItem, i) => {
      const { sourceUrl: sourceDefault, ...anotherProps } = tabItem;
      let historyFilter = history["REUNION"]?.replace(" ", "");

      if (
        (!reunionSelected || historyFilter === reunionSelected) &&
        tabItem.tabValue === "Backlog" &&
        MEETINGSPRE &&
        MEETINGSPRE[reunionSelected ?? historyFilter]?.backlog.includes("mstrprd")
      ) {
        tabItem.redirect = false;
      } else if (tabItem.tabValue === "Backlog" && location.pathname.includes("PRE"))
        tabItem.redirect = true;

      return !tabItem.redirect && !tabItem.redirectSources ? (
        <Typography
          key={`div-container-tabPanel-${tabItem.tabId}`}
          aria-labelledby={`simple-tab-${tabItem.tabId}`}
          component="div"
          hidden={tab !== tabItem.tabId}
          role="tabpanel"
        >
          {selectedTabs.includes(tabItem.tabId) && (
            <IFrameComponent
              key={`IFrameComponent-TabId-${tabItem.tabId}`}
              handleChange={handleChange}
              isCustom={isCustom}
              sourceUrl={isCustom ? changeUrl(tabItem) : sourceDefault}
              {...anotherProps}
            />
          )}
        </Typography>
      ) : !clickTab && tabItem.redirect && tab === tabItem.tabId ? (
        <ButtonOpenAnotherTab
          key={`ButtonOpenAnotherTab-${tabItem.tabId}-${i}`}
          handleClick={handleClickMenuItemRedirectCashflow}
          tabItem={tabItem}
        />
      ) : clickTab && tabItem.redirect && tab === tabItem.tabId ? (
        <ButtonOpenAnotherTab
          key={`ButtonOpenAnotherTab-${tabItem.tabId}-${i}`}
          handleClick={handleClickMenuItemRedirect}
          tabItem={tabItem}
        />
      ) : tabItem.redirectSources && tabItem.redirectSources.length > 0 ? null : null;
    });

  return (
    <>
      {tabs &&
        tabs.length > 0 &&
        tabs.map((tabItem) => {
          return (
            <div key={`div-container-filters-${tabItem.tabId}`}>
              {tabItem.tabId === tab ? (
                <IFrameControl
                  key={`Filter-tabId-${tabItem.tabId}`}
                  filters={tabItem.filters}
                  isCustom={isCustom}
                  setRenderMenu={setRenderMenu}
                  sourceUrl={tabItem.sourceUrl}
                />
              ) : null}
            </div>
          );
        })}
      {renderMenu === 3 && (
        <Grid container spacing={0} style={{ margin: "auto" }}>
          <Grid item xs={12}>
            <StyledTabs
              aria-label="disabled tabs example"
              indicatorColor="primary"
              scrollButtons="auto"
              textColor="primary"
              value={tab}
              variant="scrollable"
              onChange={handleChange}
            >
              {tabs &&
                renderMenu === 3 &&
                tabs.map((tab) => (
                  <TabStyle
                    key={`Tab-${tab.tabId}`}
                    label={tab.tabValue}
                    value={tab.tabId}
                    onClick={handleClickTab(tab.tabId)}
                  />
                ))}
            </StyledTabs>
          </Grid>
        </Grid>
      )}

      {renderMenu === 3 && tabsIframe}
      {tabWithMenu && (
        <Menu
          keepMounted
          anchorEl={anchorEl}
          id="simple-menu"
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
          {menuItems(tabWithMenu)}
        </Menu>
      )}
      <ControlComponent isCustom={isCustom} tabId={tab} />
      <HelpModal />
    </>
  );
};

LayoutWithTabs.propTypes = {
  isCustom: PropTypes.bool,
};

//Si las propiedades no cambian no lo re-renderizan.
export default React.memo(LayoutWithTabs);
